import { type FC, memo, useMemo } from 'react'
import styled from 'styled-components'
import { FlexDivRow } from './layout/flex'

type Props = {
	currentStep: number
	totalSteps: number
}

const ProgressIndicator: FC<Props> = memo(({ currentStep, totalSteps }) => {
	const stepList = useMemo(
		() =>
			Array.from({ length: totalSteps }, (_, index) => ({
				key: `step-${index}`,
			})),
		[totalSteps]
	)

	return (
		<div>
			<StepIndicatorContainer>
				{stepList.map(({ key }, index) => {
					return <StepIndicator key={key} isActive={index <= currentStep - 1} />
				})}
			</StepIndicatorContainer>
		</div>
	)
})

const StepIndicatorContainer = styled(FlexDivRow)`
	column-gap: 12px;
	margin-top: 20px;
`

const StepIndicator = styled.div<{ isActive: boolean }>`
	width: 100%;
	height: 6px;
	background: ${(props) => (props.isActive ? 'linear-gradient(44deg, #34EDB3 0%, #00D1FF 100%)' : '#2D2D38')};
	border-radius: 4px;
`

export default ProgressIndicator
